import { createFileRoute } from "@tanstack/react-router";
import { m } from "~/lib/i18n";

export const Route = createFileRoute("/_app/dashboard")({
  head: () => ({
    meta: [
      { title: m.dashboard_page_meta_title() },
      { content: m.dashboard_page_meta_description(), name: "description" },
    ],
  }),
  loader: ({ context, preload }) => {
    if (!preload) {
      return;
    }

    // Intent warming must not become a navigation barrier when clicked
    // mid-preload. Mounted Query consumers own loading and error states.
    void import("~/features/dashboard/dashboard-route")
      .then(({ preloadDashboardRoute }) => preloadDashboardRoute(context))
      .catch(() => {
        // Warming is best effort; the mounted page can retry failed reads.
      });
  },
});
